/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Save_Preset_ButtonInputs */

const en_subtitle_export_save_preset_button = /** @type {(inputs: Subtitle_Export_Save_Preset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save Preset`)
};

const fr_subtitle_export_save_preset_button = /** @type {(inputs: Subtitle_Export_Save_Preset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer le préréglage`)
};

const de_subtitle_export_save_preset_button = /** @type {(inputs: Subtitle_Export_Save_Preset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voreinstellung speichern`)
};

const it_subtitle_export_save_preset_button = /** @type {(inputs: Subtitle_Export_Save_Preset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva preimpostazione`)
};

const ru_subtitle_export_save_preset_button = /** @type {(inputs: Subtitle_Export_Save_Preset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохранить предустановку`)
};

const es_subtitle_export_save_preset_button = /** @type {(inputs: Subtitle_Export_Save_Preset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar ajuste preestablecido`)
};

const zh_cn2_subtitle_export_save_preset_button = /** @type {(inputs: Subtitle_Export_Save_Preset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存预设`)
};

const ja_subtitle_export_save_preset_button = /** @type {(inputs: Subtitle_Export_Save_Preset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プリセットを保存`)
};

const hi_subtitle_export_save_preset_button = /** @type {(inputs: Subtitle_Export_Save_Preset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रीसेट सहेजें`)
};

const pt_pt2_subtitle_export_save_preset_button = /** @type {(inputs: Subtitle_Export_Save_Preset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar predefinição`)
};

/**
* | output |
* | --- |
* | "Save Preset" |
*
* @param {Subtitle_Export_Save_Preset_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_save_preset_button = /** @type {((inputs?: Subtitle_Export_Save_Preset_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Save_Preset_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_save_preset_button(inputs)
	if (locale === "de") return de_subtitle_export_save_preset_button(inputs)
	if (locale === "it") return it_subtitle_export_save_preset_button(inputs)
	if (locale === "ru") return ru_subtitle_export_save_preset_button(inputs)
	if (locale === "es") return es_subtitle_export_save_preset_button(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_save_preset_button(inputs)
	if (locale === "ja") return ja_subtitle_export_save_preset_button(inputs)
	if (locale === "hi") return hi_subtitle_export_save_preset_button(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_save_preset_button(inputs)
	return en_subtitle_export_save_preset_button(inputs)
});